import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconQm3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconQm3"><Path fillRule="evenodd" clipRule="evenodd" d="M9.00015 2.58582L13.4144 7.00003L12.0002 8.41424L10.0002 6.41424V14H21.0002V16H9.41436L4.00015 21.4142L2.58594 20L8.00015 14.5858V6.41424L6.00015 8.41424L4.58594 7.00003L9.00015 2.58582Z" fill="currentColor"/></CentralIconBase>;
});

export default IconQm3;
